// extracted by mini-css-extract-plugin
export default {"mainContainer":"Home_mainContainer__RvuFi","videoBg":"Home_videoBg__O9YhY","gb":"Home_gb__7WM5o"};